import React from 'react';

const ExportExcelButton = ({ onClick, loading = false, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`flex items-center space-x-2 px-4 py-2 rounded-lg border transition-all duration-200 ${
        disabled || loading
          ? 'bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed'
          : 'bg-green-500 hover:bg-green-600 border-green-500 text-white shadow-sm hover:shadow-md'
      }`}
      title="Export to Excel"
    >
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          <span className="text-sm font-medium">Exporting...</span>
        </>
      ) : (
        <>
          <svg 
            className="w-4 h-4" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
            />
          </svg>
          <span className="text-sm font-medium">Export Excel</span>
        </>
      )}
    </button>
  );
};

export default ExportExcelButton;